import { BaseService } from './base.service'
import { ResponseWrapper } from './util'

export class AnalyticsService extends BaseService {
  static get entity() {
    return 'analytics'
  }

  static async getFailedAppointments(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/appointments/failed`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getMissedAppointments(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/appointments/missed`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getPatientsRegistered(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/patients/registered`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getBookingRatio(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/bookings/ratio`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getGeneralStats(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/general`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getSuccessfulAppointments(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/appointments/successful`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getUpcomingAppointments(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/appointments/upcoming`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getDoctorAllocation(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/doctors/allocation`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getMonthlyRevenue(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/revenue/monthly`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getUtilizationDaily(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/utilization/daily`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getRevenueMTD(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/revenue/mtd`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getUtilizationSummary(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/utilization/summary`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getUtilizationChart(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/utilization/chart`, { params })
    console.log("response", JSON.parse(JSON.stringify(response)))
    return new ResponseWrapper(response, response.data.data)
  }

  static async getUtilizationGraph(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/utilization/graph`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async getPendingPayments(params = {}) {
    const response = await this.request({ auth: true }).get(`${this.entity}/payments/pending`, { params })
    return new ResponseWrapper(response, response.data.data)
  }
}
